import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import imageCompression from 'browser-image-compression';
import _ from 'lodash-es';
import { base64JPEGToFile } from '../util/file-util';
import { presentLoader } from '../util/ion-util';
import { Camera, CameraResultType } from '@capacitor/camera';

@Injectable({
  providedIn: 'root'
})
export class CameraHandlerService {

  FILE_NAME = _.uniqueId('jpeg_');
  BASE_64_JPEG_PREFIX = 'data:image/jpeg;base64,';

  constructor(private readonly loadingCtrl: LoadingController) { }

  /**
   *
   * @returns a full size Base64-encoded JPEG image from the camera or gallery.
   */
  async getFullSizeBase64JPEGImage(): Promise<string> {
    return await this.getBase64JPEGImage();
  }

  /**
   *
   * @returns a reduced size Base64-encoded JPEG image from the camera or gallery, limited to 1MB in size
   */
  async getReducedSizeBase64JPEGImage(): Promise<string> {
    const base64JPEGImage = await this.getBase64JPEGImage();
    return await this.reduceJPEGImage(base64JPEGImage, 1);
  }

  private async getBase64JPEGImage(): Promise<string> {
    const capturedPhoto = await Camera.getPhoto({
      resultType: CameraResultType.Base64,
      quality: 100,
      promptLabelHeader: 'Select a Photo'
    });

    return capturedPhoto.base64String;
  }

  private async reduceJPEGImage(base64JPEGImage: string, maxSizeMB: number): Promise<string> {
    const loader = await presentLoader(this.loadingCtrl);
    const options = {
      maxSizeMB: maxSizeMB,
      maxWidthOrHeight: 1920
    }

    const reducedSizeJPEGFile = await imageCompression(base64JPEGToFile(base64JPEGImage, this.FILE_NAME), options);
    var reducedBase64JPEGString = await imageCompression.getDataUrlFromFile(reducedSizeJPEGFile);
    await loader.dismiss();
    return reducedBase64JPEGString.replace(this.BASE_64_JPEG_PREFIX, '');
  }
}
